import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { Base } from "ui/Scripts/source/framework/base";
import { SubPageHeader } from "../app/header";
import { customHistory } from "../../framework/customHistory";
import { Session } from "../../models/session/session";
import { MessageListLine } from "./messageListLine";
import { ActivePageType, NavigationBar } from "../app/navigation";
import { IMessageListItem } from "../../models/message/messageListItem";
import { MessageListSearchDialog } from "./messageListSearch";
import { IIdCodeNameLogo } from "../../models/common/idCodeNameLogo";
import { IUserState } from "../../models/store/storeTypes";

//MessageList
export interface IMessageListOwnProps {
}

export interface IMessageListStateProps {
    user: IUserState;
    hasMore: boolean;
    isLoading: boolean;
    page: number;
    items: IMessageListItem[];
    companyId: string;
    companies: IIdCodeNameLogo[];
    startDate: number;
    endDate: number;
    sortColumn: string;
    lastOpenedMessageId: string;
}

export interface IMessageListDispatchProps {
    loadMessages: (page: number, startDate: number, endDate: number, companyId: string) => void;
    resetMessages: () => void;
    refreshMessages: (page: number, startDate: number, endDate: number, companyId: string) => void;
    setLastOpenedMessageId: (id: string) => void;
    setReturnUrl: (url: string) => void;
    onLogout: () => void;
}

type MessageListProp = IMessageListOwnProps & IMessageListStateProps & IMessageListDispatchProps;

interface IMessageListState {
    selectedId: string;
    showListMenu: boolean;
    showSearchDialog: boolean;
    listMenuItem: IMessageListItem;
    companyName: string;
}

export class MessageList extends React.Component<MessageListProp, IMessageListState> {
    private hasBeenInitialized: boolean;
    private containerDiv: HTMLDivElement;
    private listDiv: HTMLDivElement;

    constructor(props) {
        super(props);
        this.hasBeenInitialized = false;
        this.state = { selectedId: null, showListMenu: false, showSearchDialog: false, listMenuItem: null, companyName: "" };
    }

    handleScrollSub = Base.debounce((obj: MessageList) => {
        if (obj.props.isLoading || !obj.props.hasMore) return;
        if (obj.listDiv.offsetHeight - (obj.containerDiv.clientHeight + obj.containerDiv.scrollTop) < 5) {
            obj.props.loadMessages(obj.props.page + 1, this.props.startDate, this.props.endDate, this.props.companyId);
        }
    }, 100);

    handleScroll = (message) => {
        this.handleScrollSub(this);
    };

    handleLineLongPress = (id: string) => {
        const listMenuItem = this.props.items.find(i => i.id === id);
        if (Base.isNullOrUndefined(listMenuItem)) return;
        this.setState({
            selectedId: id,
            showListMenu: true,
            listMenuItem
        });
    };

    handleRefreshList = () => {
        this.props.refreshMessages(this.props.page, this.props.startDate, this.props.endDate, this.props.companyId);
    };

    componentDidMount(): void {
        this.containerDiv.addEventListener("scroll", this.handleScroll);
        if (this.props.page === 0) { //First load
            this.props.loadMessages(1, this.props.startDate, this.props.endDate, this.props.companyId);
        } else { //Message edit back button
            this.props.refreshMessages(this.props.page, this.props.startDate, this.props.endDate, this.props.companyId);
        }
        //Scroll last opened item to view
        if (this.props.items.length > 0 && !Base.isNullOrEmpty(this.props.lastOpenedMessageId)) {
            if (this.containerDiv.scrollTo !== null && this.containerDiv.scrollTo !== undefined) {
                const index = this.props.items.findIndex(i => i.id === this.props.lastOpenedMessageId);
                if (index > -1) {
                    const elements = this.containerDiv.getElementsByClassName("lom");
                    if (elements.length > 0 && !Base.isNullOrUndefined(elements[0])) {
                        const y = (elements[0] as HTMLDivElement).offsetTop;
                        this.containerDiv.scrollTo({
                            top: y,
                            left: 0,
                            behavior: "auto"
                        });
                    }
                }
            }
            this.props.setLastOpenedMessageId("");
        }
        //Set companyName
        Session.getCompanyName().then((companyName) => {
            this.setState({
                companyName
            });
        });
        this.hasBeenInitialized = true;
    }

    componentWillUnmount(): void {
        this.containerDiv.addEventListener("scroll", this.handleScroll);
        this.props.resetMessages();
    }

    setReturnUrl = () => {
        this.props.setReturnUrl("/message");
    };

    handleLineClick = (id: string) => {
        this.props.setLastOpenedMessageId(id);
        this.setReturnUrl();
        customHistory.push("/message/" + id);
    };

    //handleAddClick = () => {
    //    this.props.setLastOpenedMessageId("");
    //    customHistory.push("/message/" + Base.emptyGuid);
    //}

    handleMenuEdit = () => {
        this.props.setLastOpenedMessageId(this.state.selectedId);
        this.setReturnUrl();
        customHistory.push("/message/" + this.state.selectedId);
        this.setState({
            showListMenu: false
        });
    };

    handleMenuCancel = () => {
        this.setState({
            showListMenu: false
        });
    };

    handleSearchMessages = () => {
        this.setState({
            showSearchDialog: true
        });
    };

    handleSearchDialogOk = (startDate: number, endDate: number, companyId: string) => {
        this.setState({
            showSearchDialog: false
        });
        this.props.refreshMessages(1, startDate, endDate, companyId);
    };

    handleSearchDialogCancel = () => {
        this.setState({
            showSearchDialog: false
        });
    };

    getListTitleSuffix = (startDate: number, endDate: number, companyId: string) => {
        let result = "";
        if (!Base.isNullOrUndefined(startDate) && !Base.isNullOrUndefined(endDate)) {
            result = result + (!Base.isNullOrEmpty(result) ? ", " : "") + Base.timeToDateStr(startDate) + "->" + Base.timeToDateStr(endDate);
        } else if (!Base.isNullOrUndefined(startDate)) {
            result = result + (!Base.isNullOrEmpty(result) ? ", " : "") + Base.timeToDateStr(startDate) + "->";
        } else if (!Base.isNullOrUndefined(endDate)) {
            result = result + (!Base.isNullOrEmpty(result) ? ", " : "") + "->" + Base.timeToDateStr(endDate);
        }
        if (!Base.isNullOrEmpty(result)) {
            result = " - " + result;
        }
        return result;
    };

    render() {
        const props = this.props;
        const state = this.state;
        const firstIndex = props.items.length > 0 ? props.items.findIndex(i => !i.isTitle) : -1;
        return (
            <div>
                <div className="pageContentContainer">
                    <div className="messageListContainer mainListContainer" ref={(elem) => { this.containerDiv = elem; }}>
                        <div className="lineContainer mainLineContainer messageList" ref={(elem) => { this.listDiv = elem; }}>
                            {this.hasBeenInitialized && !props.isLoading && props.items.length < 1 &&
                                <div className="infoContainer">
                                    <div className="alert alert-info" role="alert" dangerouslySetInnerHTML={ { __html: Translations.NoMessagesToShow } } />
                                </div>
                            }
                            {props.items.map((item, index) => (
                                <MessageListLine
                                    key={item.id}
                                    item={item}
                                    selected={state.selectedId === item.id}
                                    first={index === firstIndex}
                                    isLastOpenedMessage={item.id === props.lastOpenedMessageId}
                                    onClick={this.handleLineClick}
                                    onLongPress={this.handleLineLongPress}
                                    onRefreshList={this.handleRefreshList}
                                />
                            ))}
                        </div>
                    </div>
                </div>
                {state.showSearchDialog &&
                    <MessageListSearchDialog
                        startDate={props.startDate}
                        endDate={props.endDate}
                        companyId={props.companyId}
                        companies={props.companies}
                        onOk={this.handleSearchDialogOk}
                        onCancel={this.handleSearchDialogCancel}
                    />
                }
                <NavigationBar
                    activePage={ActivePageType.Message}
                    user={props.user}
                />
                <SubPageHeader
                    user={props.user}
                    title={Translations.CurrentTopics + this.getListTitleSuffix(props.startDate, props.endDate, props.companyId)}
                    searchIsSet={!Base.isNullOrUndefined(props.startDate) || !Base.isNullOrUndefined(props.endDate) || !Base.isNullOrUndefined(props.companyId)}
                    onSearch={this.handleSearchMessages}
                />
            </div>
        );
    }
}